/**
 =========================================================
 * Material Dashboard 2 React - v2.1.0
 =========================================================
 
 * Product Page: https://www.creative-tim.com/product/material-dashboard-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)
 
 Coded by www.creative-tim.com
 
 =========================================================
 
 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

import { useEffect } from 'react';

// react-router-dom components
import { useLocation } from 'react-router-dom';

// prop-types is a library for typechecking of props.
import PropTypes from 'prop-types';

// Material Dashboard 2 React components
import MDBox from 'components/MDBox';

// Material Dashboard 2 React context
import { setLayout, useMaterialUIController } from 'context';
import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';

function PageLayout({ background, title, display, sx, children }) {
  const { formatMessage: msg } = useIntl();

  const { dispatch } = useMaterialUIController();
  const { pathname } = useLocation();

  useEffect(() => {
    setLayout(dispatch, 'page');
  }, [dispatch, pathname]);

  return (
    <MDBox
      id="pageLayout"
      display={display}
      height="100%"
      bgColor={background}
      sx={{ overflowX: 'hidden', ...sx }}
    >
      <Helmet>
        <title>
          {msg({ id: 'product.name' })} - {title}
        </title>
      </Helmet>
      {children}
    </MDBox>
  );
}

// Setting default values for the props for PageLayout
PageLayout.defaultProps = {
  background: 'default',
  display: 'block'
};

// Typechecking props for the PageLayout
PageLayout.propTypes = {
  background: PropTypes.oneOf(['white', 'light', 'default']),
  title: PropTypes.string,
  display: PropTypes.string,
  sx: PropTypes.object,
  children: PropTypes.node.isRequired
};

export default PageLayout;
